import { makeStyles, Theme } from '@material-ui/core/styles'
import { IStyleProps } from './Interface'

export default makeStyles<Theme, IStyleProps>(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '&:not(:hover) $count': {
      color: theme?.palette?.common?.darkGrey
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center'
    }
  },
  count: {
    fontSize: 14,
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  content: {
    marginTop: 15,
    overflowX: 'hidden',
    marginRight: '-50px',
    scrollBehavior: 'smooth',
    [theme.breakpoints.down('xs')]: {
      marginRight: 0
    }
  },
  wordBanksContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center'
    }
  },
  wordbank: {
    marginRight: 5,
    marginTop: 5,
    [theme.breakpoints.down('xs')]: {
      flex: '40%',
      width: '100%',
      height: 'auto',
      '& .MuiChip-label': {
        width: 'max-content'
      },
      '& .MuiChip-label > .MuiTypography-body1': {
        wordBreak: 'break-all',
        whiteSpace: 'normal'
      }
    }
  },
  chip: {
    color: theme?.palette?.common?.darkGrey,
    backgroundColor: 'unset',
    cursor: 'pointer'
  },
  wordBankActive: {
    color: theme?.palette?.common?.white
  },
  top5Item: {
    '&:last-child': {
      paddingBottom: 0
    }
  }
}))
